import { getSearchUrlWithParams } from '@/utils/urls';

export type CategoryLink = {
    route: string;
    text: string;
};

export type Category = {
    headerLink: string;
    headerText: string;
    links: CategoryLink[];
};

export type ColumnCategories = {
    columnCategories: Category[];
};

export type MegaNavLink = ColumnCategories[];

export const art = [
    {
        columnCategories: [
            {
                headerLink: '/c/art/1/',
                headerText: 'Art',
                links: [
                    {
                        route: '/c/drawings/8/',
                        text: 'Drawings',
                    },
                    {
                        route: '/c/mixed-media-collages/9/',
                        text: 'Mixed Media & Collages',
                    },
                    {
                        route: '/c/paintings/10/',
                        text: 'Paintings',
                    },
                    {
                        route: '/c/photography/11/',
                        text: 'Photography',
                    },
                    {
                        route: '/c/prints-multiples/12/',
                        text: 'Prints & Multiples',
                    },
                    {
                        route: '/c/scrolls-screens-fan-paintings/13/',
                        text: 'Scrolls, Screens & Fan Paintings',
                    },
                    {
                        route: '/c/sculptures/14/',
                        text: 'Sculptures',
                    },
                    {
                        route: '/c/statues-statuettes/26420/',
                        text: 'Statues & Statuettes',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: 'Artists',
                links: [
                    {
                        route: '/c/art/pablo-picasso/1/18755/',
                        text: 'Pablo Picasso',
                    },
                    {
                        route: '/c/art/banksy/1/2655',
                        text: 'Banksy',
                    },
                    {
                        route: '/c/art/andy-warhol/1/1705/',
                        text: 'Andy Warhol',
                    },
                    {
                        route: '/c/art/jean-michel-basquiat/1/11965/',
                        text: 'Jean-Michel Basquiat',
                    },
                    {
                        route: '/c/art/roy-lichtenstein/1/21418/',
                        text: 'Roy Lichtenstein',
                    },
                    {
                        route: '/c/art/keith-haring/1/14133/',
                        text: 'Keith Haring',
                    },
                    {
                        route: '/c/art/francis-bacon/1/7794/',
                        text: 'Francis Bacon',
                    },
                    {
                        route: '/c/art/frank-stella/1/7962/',
                        text: 'Frank Stella',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: 'Popular Searches',
                links: [
                    {
                        route: '/c/paintings/oil/10/25830/',
                        text: 'Oil Paintings',
                    },
                    {
                        route: '/c/statues-statuettes/bronze/26420/25739/',
                        text: 'Bronze Statues',
                    },
                    {
                        route: '/c/statues-statuettes/bronze/26420/25739/',
                        text: 'Folk Art',
                    },
                    {
                        route: '/c/art/lithograph/1/25811/',
                        text: 'Lithographs',
                    },
                    {
                        route: '/c/drawings/pencil/8/25839/',
                        text: 'Pencil Drawings',
                    },
                    {
                        route: '/c/art/1/?filterTerm=portrait',
                        text: 'Portraits',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: 'Browse by Origin',
                links: [
                    {
                        route: '/c/art/asian/1/158/',
                        text: 'Asian',
                    },
                    {
                        route: '/c/art/european/1/191/',
                        text: 'European',
                    },
                    {
                        route: '/c/art/american/1/117/',
                        text: 'American',
                    },
                    {
                        route: '/c/art/african/1/105/',
                        text: 'African',
                    },
                    {
                        route: '/c/art/ancient-greek-and-roman/1/233/',
                        text: 'Ancient Greek and Roman',
                    },
                    {
                        route: '/c/art/middle-eastern/1/182/',
                        text: 'Middle Eastern',
                    },
                    {
                        route: '/c/art/catholic/1/25944/',
                        text: 'Catholic',
                    },
                    {
                        route: '/c/art/egyptian/1/190/',
                        text: 'Egyptian',
                    },
                    {
                        route: '/c/art/oceanic-pacific-rim/1/235/',
                        text: 'Oceanic/Pacific Rim',
                    },
                    {
                        route: '/c/art/ancient-egyptian/1/25702/',
                        text: 'Ancient Egyptian',
                    },
                    {
                        route: '/c/art/islamic/1/234/',
                        text: 'Islamic',
                    },
                    {
                        route: '/c/art/byzantine/1/25695/',
                        text: 'Byzantine',
                    },
                ],
            },
        ],
    },
] as MegaNavLink;

export const jewelry = [
    {
        columnCategories: [
            {
                headerLink: '/c/jewelry/6/',
                headerText: 'Jewelry',
                links: [
                    {
                        route: '/c/bracelets/89/',
                        text: 'Bracelets',
                    },
                    {
                        route: '/c/brooches-pins/90/',
                        text: 'Brooches & Pins',
                    },
                    {
                        route: '/c/cufflinks-tie-pins-tie-clips/91/',
                        text: 'Cufflinks, Tie Pins & Tie Clips',
                    },
                    {
                        route: '/c/earrings/92/',
                        text: 'Earrings',
                    },
                    {
                        route: '/c/loose-stones-beads/94/',
                        text: 'Loose Stones & Beads',
                    },
                    {
                        route: '/c/necklaces-pendants/95/',
                        text: 'Necklaces & Pendants',
                    },
                    {
                        route: '/c/rings/96/',
                        text: 'Rings',
                    },
                    {
                        route: '/c/watches/97/',
                        text: 'Watches',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: 'Featured',
                links: [
                    {
                        route: '/c/jewelry/cartier/6/3899/',
                        text: 'Cartier',
                    },
                    {
                        route: '/c/jewelry/chanel/6/4017/',
                        text: 'Chanel',
                    },
                    {
                        route: '/c/jewelry/rolex/6/21252/',
                        text: 'Rolex',
                    },
                    {
                        route: '/c/jewelry/bulova/6/3513/',
                        text: 'Bulova',
                    },
                    {
                        route: '/c/jewelry/chopard/6/4393/',
                        text: 'Chopard',
                    },
                    {
                        route: '/c/jewelry/swarovski/6/23012/',
                        text: 'Swarovski',
                    },
                    {
                        route: '/c/jewelry/bulgari/6/3512/',
                        text: 'Bulgari',
                    },
                    {
                        route: '/c/jewelry/patek-philippe/6/18874/',
                        text: 'Patek Philippe',
                    },
                    {
                        route: '/c/jewelry/tiffany-and-co/6/23545/',
                        text: 'Tiffany & Co.',
                    },
                    {
                        route: '/c/jewelry/omega/6/26176/',
                        text: 'Omega',
                    },
                    {
                        route: '/c/jewelry/van-cleef-and-arpels/6/24150/',
                        text: 'Van Cleef & Arpels',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: 'Popular Searches',
                links: [
                    {
                        route: '/c/jewelry/18k-gold/6/25707/',
                        text: '18K Gold Jewelry',
                    },
                    {
                        route: '/c/jewelry/diamond/6/25767/',
                        text: 'Diamond Jewelry',
                    },
                    {
                        route: '/c/jewelry/emerald/6/25774/',
                        text: 'Emeralds',
                    },
                    {
                        route: '/c/jewelry/sapphire/6/25865/',
                        text: 'Sapphires',
                    },
                    {
                        route: '/c/jewelry/ruby/6/25863/',
                        text: 'Rubies',
                    },
                    {
                        route: '/c/jewelry/pearl/6/25838/',
                        text: 'Pearls',
                    },
                ],
            },
        ],
    },
] as MegaNavLink;
export const asian = [
    {
        columnCategories: [
            {
                headerLink: '/c/asian/158/',
                headerText: 'Asian Antiques',
                links: [
                    {
                        route: '/c/art/asian/1/158/',
                        text: 'Art',
                    },
                    {
                        route: '/c/collectibles/asian/2/158/',
                        text: 'Collectibles',
                    },
                    {
                        route: '/c/fashion/asian/3/158/',
                        text: 'Fashion',
                    },
                    {
                        route: '/c/furniture/asian/4/158/',
                        text: 'Furniture',
                    },
                    {
                        route: '/c/jewelry/asian/6/158/',
                        text: 'Jewelry',
                    },
                    {
                        route: '/c/serveware-flatware-services/asian/86/158/',
                        text: 'Serveware, Flatware & Services',
                    },
                    {
                        route: '/c/vases-garnitures/asian/87/158/',
                        text: 'Vases & Garnitures',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: 'Browse By Origin',
                links: [
                    {
                        route: '/c/chinese/162/',
                        text: 'Chinese Antiques',
                    },
                    {
                        route: '/c/indian/176/',
                        text: 'Indian Antiques',
                    },
                    {
                        route: '/c/japanese/163/',
                        text: 'Japanese Antiques',
                    },
                    {
                        route: '/c/korean/164/',
                        text: 'Korean Antiques',
                    },
                    {
                        route: '/c/persian/185/',
                        text: 'Persian Antiques',
                    },
                    {
                        route: '/c/southeast-asian/169/',
                        text: 'Southeast Asian Antiques',
                    },
                    {
                        route: '/c/tibetan/168/',
                        text: 'Tibetan Antiques',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: 'Featured',
                links: [
                    {
                        route: '/c/asian/bronze/158/25739/',
                        text: 'Bronze',
                    },
                    {
                        route: '/c/asian/cloisonne/158/25757/',
                        text: 'Cloisonne',
                    },
                    {
                        route: '/c/han-dynasty/245/',
                        text: 'Han Dynasty',
                    },
                    {
                        route: '/c/jewelry/jade/6/25797/',
                        text: 'Jade Jewelry',
                    },
                    {
                        route: '/c/asian/porcelain/158/25849/',
                        text: 'Porcelain',
                    },
                    {
                        route: '/c/ming-dynasty/246/',
                        text: 'Ming Dynasty',
                    },
                    {
                        route: '/c/qing-dynasty/251/',
                        text: 'Qing Dynasty',
                    },
                    {
                        route: '/c/prints/woodblock/12/25903/',
                        text: 'Woodblock Prints',
                    },
                ],
            },
        ],
    },
] as MegaNavLink;
export const coins = [
    {
        columnCategories: [
            {
                headerLink: '/c/coins-currency-stamps/24/',
                headerText: 'Coins',
                links: [
                    {
                        route: '/c/bills-currency-notes/26473/',
                        text: 'Bills & Currency Notes',
                    },
                    {
                        route: '/c/bullion/26474/',
                        text: 'Bullion',
                    },
                    {
                        route: '/c/coins/26475/',
                        text: 'Coins',
                    },
                    {
                        route: '/c/exonumia/27623/',
                        text: 'Exonumia',
                    },
                    {
                        route: '/c/stamps/43/',
                        text: 'Stamps',
                    },
                    {
                        route: '/c/stock-bank-certificates/26476/',
                        text: 'Stocks, Bonds & Bank Certificates',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: 'Browse By Origin',
                links: [
                    {
                        route: '/c/coins-currency-stamps/american/24/117/',
                        text: 'American',
                    },
                    {
                        route: '/c/coins-currency-stamps/european/24/191/',
                        text: 'European',
                    },
                    {
                        route: '/c/coins-currency-stamps/asian/24/158/',
                        text: 'Asian',
                    },
                    {
                        route: '/c/coins-currency-stamps/ancient-greek-and-roman/24/233/',
                        text: 'Ancient Greek and Roman',
                    },
                    {
                        route: '/c/coins-currency-stamps/oceanic-pacific-rim/24/235/',
                        text: 'Oceanic/Pacific Rim',
                    },
                    {
                        route: '/c/coins-currency-stamps/middle-eastern/24/182/',
                        text: 'Middle Eastern',
                    },
                    {
                        route: '/c/coins-currency-stamps/egyptian/24/190/',
                        text: 'Egyptian',
                    },
                    {
                        route: '/c/coins-currency-stamps/byzantine/24/25695/',
                        text: 'Byzantine',
                    },
                    {
                        route: '/c/coins-currency-stamps/african/24/105/',
                        text: 'African',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: 'Featured Coins',
                links: [
                    {
                        route: '/search/?category_id=24&keyword=Commemorative&sort=-relevance&status=online',
                        // route: '/c/coins-currency-stamps/24/?filterTerm=Commemorative',
                        text: 'Commemoratives',
                    },
                    {
                        route: '/search/?category_id=24&keyword=Dollar&sort=-relevance&status=online',
                        // route: '/c/coins-currency-stamps/24/?filterTerm=Dollar',
                        text: 'Dollars & Half Dollars',
                    },
                    {
                        route: '/search/?category_id=24&keyword=Gold%20Coin&sort=-relevance&status=online',
                        // route: '/c/coins-currency-stamps/24/?filterTerm=Gold',
                        text: 'Gold Coins',
                    },
                    {
                        route: '/search/?category_id=24&keyword=Dime&sort=-relevance&status=online',
                        // route: '/c/coins-currency-stamps/24/?filterTerm=Dime',
                        text: 'Half-Dimes and Dimes',
                    },
                    {
                        route: '/search/?category_id=24&keyword=Nickel&sort=-relevance&status=online',
                        // route: '/c/coins-currency-stamps/24/?filterTerm=Nickle',
                        text: 'Nickels',
                    },
                    {
                        route: '/search/?category_id=24&keyword=Proof%20Set&sort=-relevance&status=online',
                        // route: '/c/coins-currency-stamps/24/?filterTerm=Proof%20Set',
                        text: 'Proof Sets',
                    },
                    {
                        route: '/search/?category_id=24&keyword=Quarter&sort=-relevance&status=online',
                        // route: '/c/coins-currency-stamps/24/?filterTerm=Quarter',
                        text: 'Quarters',
                    },
                ],
            },
        ],
    },
] as MegaNavLink;
export const furniture = [
    {
        columnCategories: [
            {
                headerLink: '/c/furniture/4/',
                headerText: 'Furniture',
                links: [
                    {
                        route: '/c/bedframes-headboards/56/',
                        text: 'Bedframes & Headboards',
                    },
                    {
                        route: '/c/cabinets-case-pieces/59/',
                        text: 'Cabinets & Case Pieces',
                    },
                    {
                        route: '/c/seating/26443/',
                        text: 'Seating',
                    },
                    {
                        route: '/c/tables/69/',
                        text: 'Tables',
                    },
                ],
            },
            {
                headerLink: '/c/cabinets-case-pieces/59/',
                headerText: 'Cabinets & Case Pieces',
                links: [
                    {
                        route: '/c/armoires-wardrobes/55/',
                        text: 'Armoires & Wardrobes',
                    },
                    {
                        route: '/c/bookcases-etageres-display-cases/58/',
                        text: 'Bookcases, Etageres & Display Cases',
                    },
                    {
                        route: '/c/chests-of-drawers-commodes/65/',
                        text: 'Chests of Drawers & Commodes',
                    },
                    {
                        route: '/c/sideboards-buffets/67/',
                        text: 'Sideboards & Buffets',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerLink: '/c/seating/26443/',
                headerText: 'Seating',
                links: [
                    {
                        route: '/c/benches-stools/57/',
                        text: 'Benches & Stools',
                    },
                    {
                        route: '/c/chairs/61/',
                        text: 'Chairs',
                    },
                    {
                        route: '/c/sofas-chaises/68/',
                        text: 'Sofas & Canapes',
                    },
                ],
            },
            {
                headerLink: '/c/tables/69/',
                headerText: 'Tables',
                links: [
                    {
                        route: '/c/coffee-tables-cocktail-tables/26614/',
                        text: 'Coffee & Cocktail Tables',
                    },
                    {
                        route: '/c/desks-writing-tables/63/',
                        text: 'Desks & Writing Tables',
                    },
                    {
                        route: '/c/dining-tables/64/',
                        text: 'Dining Tables',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: 'Browse By Style',
                links: [
                    {
                        route: '/c/furniture/art-deco/4/253/',
                        text: 'Art Deco',
                    },
                    {
                        route: '/c/chippendale/277/',
                        text: 'Chippendale',
                    },
                    {
                        route: getSearchUrlWithParams({
                            category_id: 4,
                            keyword: 'federal',
                            status: 'online',
                        }),
                        text: 'Federal Style',
                    },
                    {
                        route: getSearchUrlWithParams({
                            category_id: 4,
                            keyword: 'hollywood regency',
                            status: 'online',
                        }),
                        text: 'Hollywood Regency',
                    },
                    {
                        route: '/c/furniture/mid-century-modern/4/265/',
                        text: 'Mid-Century Modern',
                    },
                    {
                        route: getSearchUrlWithParams({
                            category_id: 4,
                            keyword: 'mission style',
                            status: 'online',
                        }),
                        text: 'Mission Style',
                    },
                    {
                        route: '/c/furniture/rococo/4/260/',
                        text: 'Rococo',
                    },
                    {
                        route: getSearchUrlWithParams({
                            category_id: 4,
                            keyword: 'queen anne',
                            status: 'online',
                        }),
                        text: 'Queen Anne',
                    },
                    {
                        route: '/c/furniture/victorian/4/275/',
                        text: 'Victorian',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: 'Featured',
                links: [
                    {
                        route: getSearchUrlWithParams({
                            category_id: 4,
                            keyword: 'Eames',
                            status: 'online',
                        }),
                        text: 'Eames Chairs',
                    },
                    {
                        route: '/c/furniture/herman-miller/4/10385/',
                        text: 'Herman Miller',
                    },
                    {
                        route: getSearchUrlWithParams({
                            category_id: 4,
                            keyword: 'hans wegner',
                            status: 'online',
                        }),
                        text: 'Hans Wegner',
                    },
                    {
                        route: '/c/furniture/paul-evans/4/19010/',
                        text: 'Paul Evans',
                    },
                    {
                        route: '/c/furniture/george-nelson/4/8661/',
                        text: 'George Nelson',
                    },
                    {
                        route: '/c/furniture/stickley/4/9563/',
                        text: 'Stickley',
                    },
                    {
                        route: '/c/furniture/milo-baughman/4/17579/',
                        text: 'Milo Baughman',
                    },
                ],
            },
        ],
    },
] as MegaNavLink;
export const collectibles = [
    {
        columnCategories: [
            {
                headerLink: '/c/collectibles/2/',
                headerText: 'Collectibles',
                links: [
                    {
                        route: '/c/advertisements-signs/38/',
                        text: 'Advertisements & Signs',
                    },
                    {
                        route: '/c/automobilia-petroliana/7/',
                        text: 'Automobilia & Petroliana',
                    },
                    {
                        route: '/c/banks-registers-adding-machines/18/',
                        text: 'Banks, Registers & Adding Machines',
                    },
                    {
                        route: '/c/books-magazines-papers/20/',
                        text: 'Books, Magazines & Papers',
                    },
                    {
                        route: '/c/breweriana-beer-signs/26426/',
                        text: 'Breweriana & Beer Signs',
                    },
                    {
                        route: '/c/cameras-photographica/21/',
                        text: 'Cameras & Photographica',
                    },
                    {
                        route: '/c/coins-currency-stamps/24/',
                        text: 'Coins, Currency & Stamps',
                    },
                    {
                        route: '/c/figurines-miniatures/28/',
                        text: 'Figurines & Miniatures',
                    },
                    {
                        route: '/c/home-hardware-tools-locks/45/',
                        text: 'Home Hardware, Tools & Locks',
                    },
                    {
                        route: '/c/hunting-fishing/26905/',
                        text: 'Hunting & Fishing',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: ' ',
                links: [
                    {
                        route: '/c/maps-globes-atlases/33/',
                        text: 'Maps, Globes & Atlases',
                    },
                    {
                        route: '/c/musical-instruments-music-stands/37/',
                        text: 'Musical Instruments & Music Stands',
                    },
                    {
                        route: '/c/pens-writing-instruments/32/',
                        text: 'Pens & Writing Instruments',
                    },
                    {
                        route: '/c/railroadiana/26431/',
                        text: 'Railroadiana',
                    },
                    {
                        route: '/c/radios-audio-equipment/26430/',
                        text: 'Radios & Audio Equipment',
                    },
                    {
                        route: '/c/religious-spiritual-objects/39/',
                        text: 'Religious & Spiritual Objects',
                    },
                    {
                        route: '/c/rocks-shells-minerals/40/',
                        text: 'Rocks, Shells & Minerals',
                    },
                    {
                        route: '/c/scientific-medical-objects/26432/',
                        text: 'Scientific & Medical Objects',
                    },
                    {
                        route: '/c/tobacciana/44/',
                        text: 'Tobacciana',
                    },
                    {
                        route: '/c/toys-trains-games/46/',
                        text: 'Toys, Dolls & Games',
                    },
                    {
                        route: '/c/vanity-items/52/',
                        text: 'Vanity Items',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: ' ',
                links: [
                    {
                        route: '/c/wine-spirits/88/',
                        text: 'Wine & Spirits',
                    },
                    {
                        route: '/c/weapons-armor/35/',
                        text: 'Weapons & Armor',
                    },
                ],
            },
        ],
    },
] as MegaNavLink;
export const home = [
    {
        columnCategories: [
            {
                headerLink: '/c/home-garden/5/',
                headerText: 'Home & Décor',
                links: [
                    {
                        route: '/c/baskets-containers/72/',
                        text: 'Baskets & Containers',
                    },
                    {
                        route: '/c/candle-holders/60/',
                        text: 'Candle Holders',
                    },
                    {
                        route: '/c/clocks/74/',
                        text: 'Clocks',
                    },
                    {
                        route: '/c/fireplaces-mantels/77/',
                        text: 'Fireplaces & Mantels',
                    },
                    {
                        route: '/c/fireplace-accessories/76/',
                        text: 'Fireplace Accessories',
                    },
                    {
                        route: '/c/garden-furniture/66/',
                        text: 'Garden Furniture',
                    },
                    {
                        route: '/c/garden-ornaments/79/',
                        text: 'Garden Ornaments',
                    },
                    {
                        route: '/c/frames-shelves-wall-decor/78/',
                        text: 'Frames, Shelves & Wall Decor',
                    },
                    {
                        route: '/c/kitchenware/26446/',
                        text: 'Kitchenware',
                    },
                    {
                        route: '/c/lighting/81/',
                        text: 'Lighting',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: ' ',
                links: [
                    {
                        route: '/c/magazine-racks/82/',
                        text: 'Magazine Racks',
                    },
                    {
                        route: '/c/mirrors/83/',
                        text: 'Mirrors',
                    },
                    {
                        route: '/c/planters/84/',
                        text: 'Planters',
                    },
                    {
                        route: '/c/rugs-carpets/85/',
                        text: 'Rugs & Carpets',
                    },
                    {
                        route: '/c/serveware-flatware-barware/86/',
                        text: 'Serveware, Flatware & Barware',
                    },
                    {
                        route: '/c/textiles/75/',
                        text: 'Textiles',
                    },
                    {
                        route: '/c/umbrella-stands-coat-stands/26878/',
                        text: 'Umbrella Stands & Coat Stands',
                    },
                    {
                        route: '/c/vases-garnitures/87/',
                        text: 'Vases & Garnitures',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: 'Featured',
                links: [
                    {
                        route: getSearchUrlWithParams({
                            keyword:
                                'tiffany OR swarovski OR steuben OR moser OR loetz OR lalique OR imperial OR fenton OR daum OR blenko OR baccarat OR murano OR "stained glass" OR "art glass"',
                        }),
                        text: 'Art Glass',
                    },
                    {
                        route: '/c/baccarat/2618/',
                        text: 'Baccarat',
                    },
                    {
                        route: '/c/kpm/26128/',
                        text: 'KPM',
                    },
                    {
                        route: '/c/murano/25937/',
                        text: 'Murano',
                    },
                    {
                        route: getSearchUrlWithParams({
                            keyword: 'limoges',
                        }),
                        text: 'Limoges',
                    },
                    {
                        route: '/c/rookwood-pottery/21341/',
                        text: 'Rookwood',
                    },
                    {
                        route: '/c/sevres-porcelain/23056/',
                        text: 'Sèvres',
                    },
                    {
                        route: '/c/lalique/14553/',
                        text: 'Lalique',
                    },
                    {
                        route: '/c/tiffany-studios/23547/',
                        text: 'Tiffany Studios',
                    },
                    {
                        route: '/c/meissen/26157/',
                        text: 'Meissen',
                    },
                ],
            },
        ],
    },
] as MegaNavLink;
export const fashion = [
    {
        columnCategories: [
            {
                headerLink: '/c/fashion/3/',
                headerText: 'Clothing',
                links: [
                    {
                        route: '/c/dresses-gowns/26840/',
                        text: 'Dresses & Gowns',
                    },
                    {
                        route: '/c/jackets-coats/26841/',
                        text: 'Jackets & Coats',
                    },
                    {
                        route: '/c/shirts-blouses/26845/',
                        text: 'Shirts & Blouses',
                    },
                    {
                        route: '/c/pants-trousers/26843/',
                        text: 'Pants & Trousers',
                    },
                    {
                        route: '/c/robes-kimonos/26844/',
                        text: 'Robes & Kimonos',
                    },
                    {
                        route: '/c/skirts/26847/',
                        text: 'Skirts',
                    },
                    {
                        route: '/c/suits-ensembles/26848/',
                        text: 'Suits & Ensembles',
                    },
                    {
                        route: '/c/sweaters/26849/',
                        text: 'Sweaters',
                    },
                    {
                        route: '/c/vets/26851/',
                        text: 'Vests',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: 'Accessories',
                links: [
                    {
                        route: '/c/belts-chatelaines/26829/',
                        text: 'Belts & Chatelaines',
                    },
                    {
                        route: '/c/canes-walking-sticks/22/',
                        text: 'Canes & Walking Sticks',
                    },
                    {
                        route: '/c/eyeglasses-spectacles/26831/',
                        text: 'Eyeglasses & Spectacles',
                    },
                    {
                        route: '/c/handbags-purses/26833/',
                        text: 'Handbags & Purses',
                    },
                    {
                        route: '/c/handkerchiefs-pocket-squares/26834/',
                        text: 'Handkerchiefs & Pocket Squares',
                    },
                    {
                        route: '/c/neckties-bowties-bolo-ties/26836/',
                        text: 'Neckties & Bow Ties',
                    },
                    {
                        route: '/c/scarves-wraps-shawls/26837/',
                        text: 'Scarves, Wraps & Shawls',
                    },
                    {
                        route: '/c/shoes/26442/',
                        text: 'Shoes',
                    },
                    {
                        route: '/c/wallets/26839/',
                        text: 'Wallets',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: 'Featured Designers',
                links: [
                    {
                        route: '/c/fashion/chanel/3/4017/',
                        text: 'Chanel',
                    },
                    {
                        route: '/c/fashion/christian-dior/3/4461/',
                        text: 'Christian Dior',
                    },
                    {
                        route: '/c/fashion/chloe/3/4385/',
                        text: 'Chloe',
                    },
                    {
                        route: '/c/fashion/gucci/3/9450/',
                        text: 'Gucci',
                    },
                    {
                        route: '/c/fashion/hermes/3/10420/',
                        text: 'Hermes',
                    },
                    {
                        route: '/c/fashion/louis-vuitton/3/15385/',
                        text: 'Louis Vuitton',
                    },
                    {
                        route: '/c/fashion/michael-kors/3/17295/',
                        text: 'Michael Kors',
                    },
                    {
                        route: '/c/fashion/yves-saint-laurent/3/25497/',
                        text: 'Yves Saint Laurent',
                    },
                ],
            },
        ],
    },
] as MegaNavLink;
